import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, styled } from "@mui/material";
import React from "react";
import { Suspense } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ImageComponent from "../OrderCard/ImageComponent";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& h2": {
    background: theme.palette.primary.main,
    color: "#fff",
    fontWeight: "500",
  },
}));

const DetailsDiv = styled(Box)(({ theme }) => ({
    background: "#fff",
    "& img": {
      height: "50px",
      width: "50px",
      objectFit: "contain",
      borderRadius: "5px",
    },
    "& p": {
      margin: "0",
      marginTop: "10px",
      marginBottom: "0",
    },
    "& small": {
      color: "grey",
      fontSize: "12px",
      lineHeight: "1.4",
    },
  }));

const ViewNotification = (props) => {
    var parser, htmlData, body;
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
  });

  useEffect(() => {
    props.sendNotificationDetail(dialogDetails)
  },[dialogDetails])

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  return (
    <StyledDialog
      open={dialogDetails.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        View Notification Message
        <IconButton onClick={handleClose}>
          <Close style={{ color: "#fff" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box pt={2}>
        <div dangerouslySetInnerHTML={{ __html: props?.notificationDetails?.message || props?.notificationDetails?.content}}>
        </div>  
        </Box> 
      </DialogContent>
    </StyledDialog>
  );
};

export default ViewNotification;
